module.exports = __webpack_public_path__ + "img/Group 427320368@2x.b7f6a4ac.png";